import { mulberry32 } from './random';

export const shuffle = <T>(xs: T[], seed = 1) => {
    const rand = mulberry32(seed);

    return xs.sort((_a, _b) => rand() - 0.5);
};

export const combineRandomly = <T>(ss: T[], seed = 1): T[][] => {
    const rand = mulberry32(seed);
    const result: T[][] = [ [] ];
    let l = Math.floor(rand() * 2 + 2);
    let c = 0;
    let p = 0;

    for (let i = 0; i < ss.length; i++) {
        result[p].push(ss[i]);
        c++;

        if (c >= l) {
            l = Math.floor(rand() * 2 + 2);
            c = 0;
            p++;
            result[p] = [];
        }
    }

    return result.filter(x => x.length !== 0);
};
